<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <div class="company-info">
          <div class="info logo">
            <img
              src="@/assets/images/footer-logo.png"
              class="logo-image"
            >
            <div class="contact-info">
              <div class="info-box">
                <img src="@/assets/images/footer-post.png">
                <p class="info-content">
                  556-0015
                </p>
              </div><div class="info-box">
                <img src="@/assets/images/footer-location.png">
                <p class="info-content mobile">
                  大阪府大阪市浪速区<br>敷津西１丁目１１−２４
                </p>
                <p class="info-content pc">
                  大阪府大阪市浪速区敷津西１丁目１１−２４
                </p>
              </div>
            </div>
          </div>
          
          <div class="info cert">
            <img
              class="cert-image"
              src="@/assets/images/ias.png"
            >
            <div class="cert-text">
              <p>弊社はISO/IEC 27001:2022を取得しています。</p>
            </div>
          </div>
        </div>
       
        <div class="navigation">
          <h4><a href="#/company-info">企業情報</a></h4>
          <ul>
            <li><a href="#/company-info#greetings">代表挨拶</a></li>
            <li><a href="#/company-info#overview">会社概要</a></li>
            <li><a href="#/company-info#history">沿革</a></li>
            <li><a href="#/company-info#partner">主要取引先</a></li>
            <li><a href="#/company-info#base">国内、海外拠点紹介</a></li>
          </ul>
        </div>    
        <div class="navigation">
          <h4><a href="#/services">事業内容</a></h4>
          <ul>
            <li><a href="#/services#siservice">SIサービス</a></li>
            <li><a href="#/services#solution">ソリューション事業</a></li>
            <li><a href="#/services#offshore">オフショア開発</a></li>
          </ul>
        </div>
        <div class="navigation">
          <h4><a href="#/sino-japan-trade">日中貿易業務</a></h4>
          <ul>
            <li><a href="#/sino-japan-trade">研磨材事業</a></li>
          </ul>
        </div>
        <div class="navigation">
          <h4><a href="#/partner">パートナー募集</a></h4>
          <h4><a href="#/recruitment">人材募集</a></h4>
          <h4><a href="#/inquiry">問い合わせ</a></h4>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>Copyright © 2019 株式会社M-NET. All Rights Reserved.</p>
    </div>
  </footer>
</template>
  
<script>
export default {
    name: "FooterView",
};
</script>
  
  <style lang="scss" scoped>
  .footer {
    background: #f2f2f2; 
    font-size: 14px;
  }
    .footer-content {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 1600px;
      margin: 0 auto;
      padding: 10px 0px;
    }
      .footer-section {
        display: flex;
        justify-content: center;
        margin: 0 10px;
        white-space: nowrap;
        gap: 0px;
      }

      .company-info {
        justify-content: center;
        align-content: center;
      }

      .info {
    display: flex;
    flex-direction: column;
    justify-content: left;
      font-size: 12px;
  }

  .mobile {
    display: none;
  }

  .cert {
    margin-top: 20px;
  }

  .logo-image {
    max-width: 100px;
  }

  .cert-image {
    max-width: 90px;
  }

  .info-content {
    position: relative;
    margin-left: 10px;
    margin-top: 6px;
    margin-bottom: 2px;
  }

  .info-content::before {
    content: "";
    display: block;
    position: absolute;
    background-color: grey;
    width: 1px;
    height: 80%;
    transform: translateY(-50%);
    left: -5px;
    top: 50%;
  }
  .info-box {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 15px;
    }
  }

      .navigation {
        margin: 0 25px;
      }

  
        h4 {
          font-size: 18px;
          margin-bottom: 40px;
          color: #0a0a0a;
          position: relative;
          font-weight: normal;

          a {
              text-decoration: none;
              transition: color 0.3s;
              color: #333333;
  
              &:hover {
                color: red; /* 鼠标悬停效果 */
              }
            }
        }

        h4::after {
          content:"";
          display: block;
          position: absolute;
          height: 2px;
          width: 20%;
          bottom: -5px;
          background: red;
        }
  
        ul {
          list-style: none;
          padding: 0;
  
          li {
            margin: 18px 0;
  
            a {
              color: #575757;
              text-decoration: none;
              transition: color 0.3s;
              font-size: 16px;
  
              &:hover {
                color: red; /* 鼠标悬停效果 */
              }
            }
          }
        }

    .footer-bottom {
      text-align: center;
      background: #333333;
      border-top: 1px solid #444;
  
      p {
        margin: 5px 0;
        font-size: 16px;
        color: #ccc;
      }
    }

    @media (max-width:1060px) {

      .footer {
        background: #f2f2f2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 95%;
      }

      .footer-content {
        padding: 0;
        margin: 20px 0;
        justify-content: space-between;
      }

      .footer-section {
        display: flex;
        justify-content: center;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        gap: 0px;
        width: 100%;
      }

      .navigation {
        display: none;
      }

      .company-info {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 95%;
      }

      .mobile {
        display: flex;
      }

      .pc {
        display: none;
      }

      .cert {
        margin-top: 0;
      }

      .cert-image {
        width: 40px;
      }

      .logo {
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 10px
      }

      .logo-image {
        width: 60px;
      }

      .contact-info {
        display: flex;
        flex-direction: column;
        gap: 3px;
      }


      .cert-text {
        display: none;
      }

      .info-box img {
        width: 15px;
      }

      .info-box p {
        font-size: 10px;
        margin-top: 0;
        margin-bottom: 0;
      }

      .footer-bottom {
        background: #f2f2f2;
        border-top: 1px solid rgb(215, 215, 215);
        width: 100%;
        padding: 0;
        margin: 0;
        p {
          font-size: 10px;
        }
      }
    }
  
  </style>
  